// src/pages/yachts/special-offers/advertisedLocations.js
// Mirrors the WEB-4877 server rule: a location restriction may only name destinations
// that a season of the yacht WITH rates advertises during the charter window.

const day = (v) => String(v).slice(0, 10);

export default function advertisedLocationIds(seasons, dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return null;
    const from = day(dateFrom);
    const to = day(dateTo);
    const ids = new Set();
    (seasons || []).forEach((s) => {
        if (!(s.rates || []).length) return;
        if (day(s.date_from) > to || day(s.date_to) < from) return;
        (s.locations || []).forEach((l) => ids.add(Number(l.id)));
    });
    return [...ids];
}
